'use strict';
const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = BaseView.extend({
    errorMaxLength: 50,
    initialize: function() {
        this.render();
        this.prepareLoginStartInfo();
    },
    selectors: {
        'resetPasswordButton': '.reset_password_button',
        'resetPasswordInput': '.reset_password_input',
        'resetPasswordDiv': '.reset_password_div',
        'resetPasswordIcon': '.password_icon',
        'backToLogin': '.back_to_login',
        'legacyUserElements': '.legacy_user',
        'resetpasswordTitle': '.resetpassword_title',
        'loginStartInfo': '.login_start_info',
        'infoProtection': '.info_protection',
        'infoTerms': '.info_terms',
    },

    events: {
        'tap .reset_password_button': 'resetPassword',
        'tap .password_icon': 'changePasswordCharsViewer',
        'tap .back_to_login': 'openLoginForm',
        'tap .info_protection': 'onTapInfoProtection',
        'tap .info_terms': 'onTapInfoTerms',
    },
    render() {
        const {keys} = this;
        this.$el.html(this.templates.main({keys}));
    },
    _trackEvent(label) {
        trackingUtils.trackEventWithCategory(this.model.isLegacy ? 'sso_legacy_pwd' : 'sso_change_pwd', 'password_set_new', label);
    },

    _clearErrors() {
        this.$el.find(this.selectors.resetPasswordDiv).removeClass('invalid').removeClass('invalid-long');
        this.$el.find('.error_long_message').text('');
        this.$el.find('.error_message').text('');
    },

    resetPassword() {
        const passwordInput = this.$el.find(this.selectors.resetPasswordInput);
        const password = passwordInput.val();
        const type = passwordInput.data('validationType');
        let error = 'invalid';

        this._clearErrors();

        if (this.model.hashCode !== '' && Odigeo.Utils.isValid(type, password, true)) {
            this._trackEvent('change_password');
            Odigeo.trigger(this.id + ':showHideModalLayer', true);
            Odigeo.trigger(this.id + ':submitUserRequest', {
                action: 'changePasswordWithCode',
                data: {
                    newPassword: password,
                    hashCode: this.model.hashCode,
                },
            });
        } else {
            this._trackEvent('sso_pwd_pci_compliance_error');
            if (this.model.hashCode === '') {
                error = 'errorcode';
            } else if (password === '') {
                error = 'empty';
            }
            this.passwordError(error);
        }
    },

    changePasswordCharsViewer() {
        const input = this.$el.find(this.selectors.resetPasswordInput);
        this.$el.find(this.selectors.resetPasswordIcon).find('.password_char_viewer').toggleClass('odf-hidden');
        input.attr('type', input.attr('type') === 'password' ? 'text' : 'password');
    },

    openLoginForm() {
        trackingUtils.trackEventWithCategory('sso_module', 'password_recovery', 'go_to_login');
        Odigeo.trigger(this.id + ':openLoginForm');
    },

    passwordError(error) {
        const errorText = this.$el.find(this.selectors.resetPasswordInput).data(error);
        const isLongError = errorText.length > this.errorMaxLength;
        if (error === 'backerror') {
            this._trackEvent('recovery_error_token_used');
        }
        Odigeo.trigger(this.id + ':showHideModalLayer', false);
        this.$el.find(this.selectors.resetPasswordDiv).addClass(isLongError ? 'invalid-long' : 'invalid');
        this.$el.find(isLongError ? '.error_long_message' : '.error_message').text(errorText);
    },

    prepareLoginStartInfo() {
        const infoProtection = '<span class="info_protection">' + this.keys.registerFormCreateInfoProtection + '</span>';
        const infoTerms = '<span class="info_terms">' + this.keys.registerFormCreateInfoTerms + '</span>';
        const loginStartInfo = Odigeo.Utils.replaceCmsKeyArgs(this.keys.registerFormCreateInfo, infoProtection, infoTerms);

        this.$el.find(this.selectors.loginStartInfo).html(loginStartInfo);
    },

    onTapInfoProtection() {
        this._trackEvent('privacy_policy_clicks');
    },

    onTapInfoTerms() {
        this._trackEvent('terms_and_conditions_clicks');
    },

    setRecoverCode() {
        const resetPasswordButton = this.$el.find(this.selectors.resetPasswordButton);
        const resetPasswordTitle = this.$el.find(this.selectors.resetpasswordTitle);

        this.$el.find('.reset_password').addClass('od-legacy');
        this.$el.find(this.selectors.legacyUserElements).removeClass('hidden');
        resetPasswordButton.text(resetPasswordButton.data('legacy'));
        resetPasswordTitle.text(resetPasswordTitle.data('legacy'));
    },
});
